import {
  DebugForm,
  DisplayFormErrors,
  ReportingMelcoMachineStatisticsModelsViewerLink,
  useConfirm,
  VerticalForm,
} from "melco-shared-logic";
import {
  Alert,
  Button,
  Col,
  CopyableTextWithLabel,
  DeleteIcon,
  FullWidthSpace,
  Row,
  Space,
  Text,
  useMessage,
} from "melco-ui";
import { useTranslation } from "react-i18next";
import { QRCode } from "antd";
import { useDeleteViewerLink } from "../../../../hooks/reporting/useDeleteViewerLink";
import { isEmpty } from "lodash-es";
import dayjs from "dayjs";
import styled from "styled-components";

type DisplayDetailViewerLinkFormProps = {
  viewerLinkDetail: ReportingMelcoMachineStatisticsModelsViewerLink;
  viewId: string;
  closeAndReset: () => void;
};

const EmptyPasswordWrapper = styled.div`
  height: 10px;
  width: 100%;
  margin: 5px;
`;

export const DisplayDetailViewerLinkForm: React.FC<
  DisplayDetailViewerLinkFormProps
> = ({ viewId, closeAndReset, viewerLinkDetail }) => {
  const { t } = useTranslation();
  const message = useMessage();

  const deleteViewerLink = useDeleteViewerLink();

  const confirmDelete = useConfirm(
    async () => {
      if (viewId) {
        const successfullyDeletedViewerLink = await deleteViewerLink(viewId);

        if (!isEmpty(successfullyDeletedViewerLink)) {
          closeAndReset();
        }
      }
    },
    {
      translationPrefix:
        "reporting.machinestatus.view.viewerlink.actions.delete",
      translationOptions: {
        count: 1,
      },
      content: (
        <Space direction="vertical" size="small">
          {t(
            "reporting.machinestatus.view.viewerlink.actions.delete.confirmation.message_one"
          )}
        </Space>
      ),
    }
  );

  // const unsecuredCopyToClipboard = (text: string) => {
  //   const textArea = document.createElement("textarea");
  //   textArea.value = viewerLinkDetail?.password ?? "";
  //   document.body.appendChild(textArea);
  //   textArea.focus();
  //   textArea.select();
  //   try {
  //     document.execCommand("copy");
  //   } catch (err) {
  //     console.error("Unable to copy to clipboard", err);
  //   }
  //   document.body.removeChild(textArea);
  // };

  /**
   * Copies the text passed as param to the system clipboard
   * Check if using HTTPS and navigator.clipboard is available
   * Then uses standard clipboard API, otherwise uses fallback
   */
  const copyToClipboard = (content: string) => {
    if (window.isSecureContext && navigator.clipboard) {
      navigator.clipboard.writeText(content);
    } else {
      //unsecuredCopyToClipboard(content);
    }
  };

  return (
    <VerticalForm>
      <DisplayFormErrors />

      <FullWidthSpace direction="vertical" size="middle">

        <Text>
          {t("reporting.machinestatus.view.viewerlink.drawer.message")}
        </Text>

        <Alert
          type="info"
          closable={false}
          message={
            viewerLinkDetail.days !== -1
              ? t(
                "reporting.machinestatus.view.viewerlink.drawer.valid_until_message"
              ) +
              dayjs(viewerLinkDetail.expires_on).format("YYYY-MM-DD, ha")
              : t(
                "reporting.machinestatus.view.viewerlink.drawer.valid_forever_message"
              )
          }
          withBackground
        // style={{ width: "100%" }}
        />

        {/* </Space> */}
        <Row>
          <Col xs={24} md={24}>
            <Space direction="vertical" size="middle">
              <a
                data-cy-id="viewer-link-url"
                href={viewerLinkDetail?.link ?? ""}
                target="_blank"
              >
                <CopyableTextWithLabel
                  label={"Link"}
                  text={viewerLinkDetail?.link ?? ""}
                  copiedTooltip={t(
                    "reporting.machinestatus.view.viewerlink.actions.copy.link.copiedtooltip"
                  )}
                  copyTooltip={t(
                    "reporting.machinestatus.view.viewerlink.actions.copy.link.copytooltip"
                  )}
                  onCopiedMessage={t(
                    "reporting.machinestatus.view.viewerlink.actions.copy.link.oncopiedmessage"
                  )}
                  key={"link-copy"}
                />
              </a>
            </Space>
          </Col>
          <Col xs={24} md={24}>
            <QRCode
              data-cy-id="viewer-link-qr-code"
              value={viewerLinkDetail?.link ?? ""}
            />
          </Col>
        </Row>

        <Row>
          {/* <Col xs={24} md={24}>
            <Text data-cy-id="viewer-link-password">
              {t(
                "reporting.machinestatus.view.viewerlink.drawer.form.password"
              )}
            </Text>
          </Col> */}
          <Col xs={24} md={24}>
            <div data-cy-id="viewer-link-copy-password">
              {viewerLinkDetail?.password ? (
                // <>
                // <PasswordField password={viewerLinkDetail?.password} /><Text
                //   copyable={{
                //     onCopy: () => {
                //       copyToClipboard(viewerLinkDetail?.password ?? "");
                //       message.success(
                //         t(
                //           "reporting.machinestatus.view.viewerlink.actions.copy.password.oncopiedmessage"
                //         )
                //       );
                //     },
                //     tooltips: [
                //       t(
                //         "reporting.machinestatus.view.viewerlink.actions.copy.password.copytooltip"
                //       ),
                //       t(
                //         "reporting.machinestatus.view.viewerlink.actions.copy.password.oncopiedmessage"
                //       ),
                //     ],
                //   }}
                // >
                //   {/* {"*******************************"} */}
                // </Text>

                //   {/* <PasswordField password={viewerLinkDetail?.password} /> */}
                // </>
                <>
                  <CopyableTextWithLabel
                    label={"Password"}
                    text={viewerLinkDetail?.password ?? ""}

                    copiedTooltip={t(
                      "reporting.machinestatus.view.viewerlink.actions.copy.password.oncopiedmessage"
                    )}
                    copyTooltip={t(
                      "reporting.machinestatus.view.viewerlink.actions.copy.password.copytooltip"
                    )}
                    onCopiedMessage={t(
                      "reporting.machinestatus.view.viewerlink.actions.copy.password.oncopiedmessage"
                    )}
                    key={"password-copy"}
                  />
                </>
              ) : (
                <EmptyPasswordWrapper></EmptyPasswordWrapper>
              )}
            </div>
          </Col>
        </Row>

        <Button
          key="view-link-delete"
          type="primary"
          icon={<DeleteIcon />}
          data-cy-id="view-link-delete-button"
          onClick={async () => {
            confirmDelete();
          }}
        //loading={isLoading}
        >
          {t("reporting.machinestatus.view.viewerlink.actions.delete.button")}
        </Button>
      </FullWidthSpace>

      {false && <DebugForm />}
    </VerticalForm>
  );
};
